// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nsAddressForm_aDFsH .dualColumn_CdRd2{display:flex;align-content:space-between}.nsAddressForm_aDFsH .dualColumn_CdRd2 .firstCol_3XTDT{margin-right:20px}.optional_3pcji{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"nsAddressForm": "nsAddressForm_aDFsH",
	"dualColumn": "dualColumn_CdRd2",
	"firstCol": "firstCol_3XTDT",
	"optional": "optional_3pcji"
};
module.exports = exports;
